import { checkPinToken } from '@/services/authHelper';
import userService from '@/services/users';

/**
 * Checks PIN-related logic
 *
 * @example
 * const { isUserNotOnThePinScreen } = useLoginPin();
 */
const useLoginPin = () => {
  const { pinData } = userService.pin.usePinData();

  const isUserHasPin = pinData?.has_set_pin;
  const isPinTokenTheSameAsStoredInLocalStorage = checkPinToken();

  const hasUserCreatedPin = !isUserHasPin && !isPinTokenTheSameAsStoredInLocalStorage;
  const hasUserEnteredPin = isUserHasPin === true && !isPinTokenTheSameAsStoredInLocalStorage;

  const isUserNotOnThePinScreen = !hasUserCreatedPin && !hasUserEnteredPin;

  return {
    isUserNotOnThePinScreen,
    hasUserCreatedPin,
  };
};

export default useLoginPin;
